import { Timestamp } from 'firebase/firestore';
import React from 'react';

import { useAppSelector } from '@core/hooks/appHooks';
import { NetworkService } from '@core/services/networkService/networkService';
import { selectVendor } from '@core/store/appSlice/appSlice';
import DemmiIconButton, { IconButtonSize } from '@demmi-ui/IconButton';
import DemmiSelect from '@demmi-ui/Select/Select';
import { SelectContent, SelectItem } from '@demmi-ui/Select/_types';
import { demmiRequest } from '@helpers/app.helper';
import { DemmiFS } from '@subhanhabib/demmilib';

interface Props {
  order: DemmiFS.Order;
  status: string;
}

const OrderItemHeader: React.FC<Props> = ({ order, status }) => {
  const CSSBlock = 'order-item-header';
  const vendor = useAppSelector(selectVendor);

  const updateStatus = (
    status: DemmiFS.OrderStatusHelper.OrderVendorStatus,
  ) => {
    if (vendor && order)
      demmiRequest(
        NetworkService.Orders.updateOrderStatus(order.docID, {
          vendorID: vendor.docID,
          timestamp: Timestamp.now(),
          statusUpdate: status,
          updatedBy: DemmiFS.OrderTimelineHelper.UpdatedBy.VENDOR,
        }),
      );
  };

  const menuItems = [
    {
      id: DemmiFS.OrderStatusHelper.OrderVendorStatus.IN_PROGRESS,
      text: DemmiFS.OrderStatusHelper.getOrderVendorStatusText(
        DemmiFS.OrderStatusHelper.OrderVendorStatus.IN_PROGRESS,
      ),
      item: DemmiFS.OrderStatusHelper.OrderVendorStatus.IN_PROGRESS,
    } as SelectItem<DemmiFS.OrderStatusHelper.OrderVendorStatus>,
    {
      id: DemmiFS.OrderStatusHelper.OrderVendorStatus.READY_FOR_COLLECTION,
      text: DemmiFS.OrderStatusHelper.getOrderVendorStatusText(
        DemmiFS.OrderStatusHelper.OrderVendorStatus.READY_FOR_COLLECTION,
      ),
      item: DemmiFS.OrderStatusHelper.OrderVendorStatus.READY_FOR_COLLECTION,
    } as SelectItem<DemmiFS.OrderStatusHelper.OrderVendorStatus>,
    {
      id: DemmiFS.OrderStatusHelper.OrderVendorStatus.COLLECTED,
      text: DemmiFS.OrderStatusHelper.getOrderVendorStatusText(
        DemmiFS.OrderStatusHelper.OrderVendorStatus.COLLECTED,
      ),
      item: DemmiFS.OrderStatusHelper.OrderVendorStatus.COLLECTED,
    } as SelectItem<DemmiFS.OrderStatusHelper.OrderVendorStatus>,
  ];

  const content: SelectContent<DemmiFS.OrderStatusHelper.OrderVendorStatus> = {
    sections: [
      {
        items: menuItems,
      },
    ],
  };

  return (
    <div className={`${CSSBlock}`}>
      <div className={`${CSSBlock}__id`}>{`Order #${order.orderID}`}</div>
      <div className={`${CSSBlock}__status`}>
        <div className={`${CSSBlock}__status-badge`}>{status}</div>
        <DemmiSelect<DemmiFS.OrderStatusHelper.OrderVendorStatus>
          content={content}
          value=""
          triggerEl={
            <DemmiIconButton
              size={IconButtonSize.MINI}
              faIcon="fa-caret-down"
            />
          }
          onChange={c => {
            updateStatus(c as DemmiFS.OrderStatusHelper.OrderVendorStatus);
          }}
        />
      </div>
    </div>
  );
};

export default OrderItemHeader;
